export default __webpack_public_path__ + "static/artists1-6deee5872b09e01b774a2985a7e6a90b.jpg";